import { css, styled } from 'styled-components'
import { GALLERY_WALL_SHADOW_URL } from '../../upsellWall'

// Both gallery wall textures span an 8.4" tile, so their borders keep the same size in inches on any tile.
const TEXTURE_TILE_INCHES = 8.4
const FRAME_TEXTURE = { sizePx: 1340, borderPx: 40 }
const SHADOW_TEXTURE = { sizePx: 2020, borderPx: 340 }
// The design's speed for a tile turning off or on: its grey wash and its toggle circle.
export const TILE_TOGGLE_DURATION_MS = 350

function getTextureBorderWidth({
  sizePx,
  borderPx,
}: typeof FRAME_TEXTURE): string {
  const borderInches = (borderPx / sizePx) * TEXTURE_TILE_INCHES
  return `calc(${borderInches} / var(--tile-width-inches) * 100cqw)`
}

// Fits its square wall cell in either orientation; its layers' cqw measure its width.
export const Tile = styled.div<{ $isPortrait: boolean }>`
  position: relative;
  container-type: inline-size;
  ${({ $isPortrait }) =>
    $isPortrait
      ? css`
          height: 100%;
          max-width: 100%;
        `
      : css`
          width: 100%;
          max-height: 100%;
        `}
`

// Reaches past the gap onto the next tiles, where it would take their taps.
export const Shadow = styled.div`
  --shadow-width: ${getTextureBorderWidth(SHADOW_TEXTURE)};
  position: absolute;
  inset: calc(-1 * var(--shadow-width));
  border: var(--shadow-width) solid transparent;
  border-image: url(${GALLERY_WALL_SHADOW_URL}) ${SHADOW_TEXTURE.borderPx} fill
    stretch;
  pointer-events: none;
`

export const PhotoClip = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
`

export const Photo = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  object-fit: cover;
`

// The texture's centre carries the frame's inner shadow over the photo's edges.
export const Frame = styled.div`
  position: absolute;
  inset: 0;
  border: ${getTextureBorderWidth(FRAME_TEXTURE)} solid transparent;
  border-image-slice: ${FRAME_TEXTURE.borderPx} fill;
  border-image-repeat: stretch;
`

// The design's grey wash over a turned-off tile's photo.
export const TurnedOffOverlay = styled.div<{ $isTurnedOff: boolean }>`
  position: absolute;
  inset: 0;
  background-color: rgba(132, 132, 132, 0.7);
  opacity: ${({ $isTurnedOff }) => ($isTurnedOff ? 1 : 0)};
  pointer-events: none;
  transition: opacity ${TILE_TOGGLE_DURATION_MS}ms;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`
